import { TRACKING_EVENT_NAMES, DEFAULT_ENTITIES } from './constants'
import { useTrack } from './useTrack'

const defaultAvailabilityLocation = 'global_availability_page'

export const useTrackAvailabilityInteraction = ({ eventType, location, ...properties } = {}) => {
  const track = useTrack()

  return (dynamicProperties = {}) => {
    const dependencies = {
      ...(eventType ? { event_type_uuid: eventType.uuid } : {})
    }

    const entities = [...DEFAULT_ENTITIES, ...(eventType ? ['event_type'] : [])]

    return track({
      name: TRACKING_EVENT_NAMES.AVAILABILITY_INTERACTION,
      dependencies,
      entities,
      properties: {
        location: location || defaultAvailabilityLocation,
        ...properties,
        ...dynamicProperties
      }
    })
  }
}
